export const SESSION_STORAGE_KEYS = {
	PRESENT_ID: 'presentIds',
	ABSENT_ID: 'absentIds',
	ATTENDANCE_FORM_DATA: 'attendanceFormData',
	CURRENT_USER: 'currentUser',
	CURRENT_USER_ROLE: 'currentUserRole',
	ATTENDANCE: 'attendance',
};

export function getUserFromSessionStorage() {
	const user = sessionStorage.getItem(SESSION_STORAGE_KEYS.CURRENT_USER);
	return user ? JSON.parse(user) : undefined;
}

export function saveUserInSessionStorage(user) {
	sessionStorage.setItem(SESSION_STORAGE_KEYS.CURRENT_USER, JSON.stringify(user));
}

export const removeUserFromSessionStorage = () => {
	sessionStorage.removeItem(SESSION_STORAGE_KEYS.CURRENT_USER);
};

export function getUserRoleFromSessionStorage() {
	const role = sessionStorage.getItem(SESSION_STORAGE_KEYS.CURRENT_USER_ROLE);
	return role ? JSON.parse(role) : undefined;
}

export function saveUserRoleInSessionStorage(role) {
	sessionStorage.setItem(SESSION_STORAGE_KEYS.CURRENT_USER_ROLE, JSON.stringify(role));
}

export const removeUserRoleFromSessionStorage = () => {
	sessionStorage.removeItem(SESSION_STORAGE_KEYS.CURRENT_USER_ROLE);
};
export const getPresentIdsFromSessionStorage = () => {
	const presentIds = sessionStorage.getItem(SESSION_STORAGE_KEYS.PRESENT_ID);
	return presentIds ? JSON.parse(presentIds) : [];
};

export const setPresentIdsInSessionStorage = (presentIds) => {
	sessionStorage.setItem(SESSION_STORAGE_KEYS.PRESENT_ID, JSON.stringify(presentIds));
};

export const removePresentIdsFromSessionStorage = () => {
	sessionStorage.removeItem(SESSION_STORAGE_KEYS.PRESENT_ID);
};

export const getAbsentIdsFromSessionStorage = () => {
	const absentIds = sessionStorage.getItem(SESSION_STORAGE_KEYS.ABSENT_ID);
	return absentIds ? JSON.parse(absentIds) : [];
};

export const setAbsentIdsInSessionStorage = (absentIds) => {
	sessionStorage.setItem(SESSION_STORAGE_KEYS.ABSENT_ID, JSON.stringify(absentIds));
};

export const removeAbsentIdsFromSessionStorage = () => {
	sessionStorage.removeItem(SESSION_STORAGE_KEYS.ABSENT_ID);
};

export const getAttendanceFormDataFromSessionStorage = (defaultValue) => {
	const attendanceFormData = sessionStorage.getItem(SESSION_STORAGE_KEYS.ATTENDANCE_FORM_DATA);
	return attendanceFormData ? JSON.parse(attendanceFormData) : defaultValue;
};

export const setAttendanceFormDataInSessionStorage = (formData) => {
	sessionStorage.setItem(SESSION_STORAGE_KEYS.ATTENDANCE_FORM_DATA, JSON.stringify(formData));
};

export const removeAttendanceFormDataFromSessionStorage = () => {
	sessionStorage.removeItem(SESSION_STORAGE_KEYS.ATTENDANCE_FORM_DATA);
};

export const setAttendanceInSessionStorage = (attendance) => {
	sessionStorage.setItem(SESSION_STORAGE_KEYS.ATTENDANCE, JSON.stringify(attendance));
};

export const getAttendanceFromSessionStorage = () => {
	const attendance = sessionStorage.getItem(SESSION_STORAGE_KEYS.ATTENDANCE);
	return attendance ? JSON.parse(attendance) : [];
};

export const removeAttendanceFromSessionStorage = () => {
	sessionStorage.removeItem(SESSION_STORAGE_KEYS.ATTENDANCE);
};
